import PropTypes from 'prop-types';
import React from 'react';
import BookingRequestBadge from './BookingRequestBadge';

class BookingRequestList extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  render() {
    const hotels = [];
    this.props.requests.forEach((request) => {
      hotels.push(<BookingRequestBadge request={request} key={request.id} />);
    });
    return (
      <div className="content-tours">
        <div className="container-fluid">
          <div className="row tour-head">
            <div className="col-md-12 tour-headText">
              <h2>Booking Requests</h2>
              <hr />
            </div>
          </div>
          <div className="row">
            {hotels}
          </div>
        </div>
      </div>
    );
  }
}
BookingRequestList.propTypes = {
};
export default BookingRequestList;



// WEBPACK FOOTER //
// src/routes/booking/components/BookingRequestList.js